import { clientHttp } from '@/common/http';
import {
  GetBestRankingStoreItemsApi,
  getBestRankingStoreItemsInputSchema,
  getBestRankingStoreItemsResponseSchema,
} from './get-best-ranking-store-items';

export const getBestRankingStoreItems: GetBestRankingStoreItemsApi = async ({
  input,
  headers,
  signal,
}) => {
  try {
    const params = getBestRankingStoreItemsInputSchema.parse(input);
    const searchParams = new URLSearchParams();
    searchParams.set('type', params.type);

    if (params.filter) {
      searchParams.set('filter', JSON.stringify(params.filter));
    }

    if (params.isLoggedIn) {
      searchParams.set('isLoggedIn', 'true');
    }

    if (params.showCouponBadge) {
      searchParams.set('showCouponBadge', 'true');
    }

    const json = await clientHttp
      .get(
        `/api/promotions/store-items/best-ranking?${searchParams.toString()}`,
        { headers, signal },
      )
      .json();
    return getBestRankingStoreItemsResponseSchema.parse(json);
  } catch {
    return {
      items: [],
      chips: [],
    };
  }
};
